/**
 * Teaching lines for empty lists. When the routes, marks, or tracks list has
 * nothing in it yet, we don't leave a blank — we show one calm, friendly line
 * that tells a new skipper how to make the first one. The copy is Edd's, verbatim.
 *
 * Kept as plain constants (rather than inline in each sheet) so the exact wording
 * lives in one place and can be checked in a test, and so every list uses the
 * same phrasing.
 */

/** Shown in the Routes list when there are no routes yet. */
export const EMPTY_ROUTES =
  'No routes yet. Press and hold the chart to drop your first waypoint, or hit Set destination and let the app plot one for you.';

/** Shown in the Marks list when there are no saved marks yet. */
export const EMPTY_MARKS =
  'No marks saved yet. Press and hold anywhere on the chart to drop one, then give it a name and an icon.';

/** Shown in the Saved tracks list when there are no saved tracks yet. */
export const EMPTY_TRACKS =
  "No saved tracks yet. Your track records as you go, save one once you've been somewhere worth remembering.";

/**
 * The hint for a list of the given kind, or null when the list has items (so the
 * caller shows the list instead). A tiny helper, but it keeps the "empty vs not"
 * decision in one testable place.
 */
export function emptyHintFor(kind: 'routes' | 'marks' | 'tracks', count: number): string | null {
  if (count > 0) return null;
  switch (kind) {
    case 'routes':
      return EMPTY_ROUTES;
    case 'marks':
      return EMPTY_MARKS;
    case 'tracks':
      return EMPTY_TRACKS;
  }
}
